module.exports = "pegasus/assets/themelp1/webinar/100.png";